import React from "react";
import {Route, BrowserRouter, Routes, Navigate} from "react-router-dom";
import Login from "../Pages/Login";
import Agendamentos from "../Pages/Agendamentos";
import Configuracao from "../Pages/Configuracao";
import { AuthProvider } from "../Auth/AuthContext";
import PrivateRoute from "../Auth/PrivateRoute";
import Lancamentos from "../Pages/Lancamentos";
import Dashboard from "../Pages/Dashboard";

const Rotas = () => {
    return(
        <React.StrictMode>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element = { <Login/> } path="/"/>
                        <Route path="/Agendamentos" element={
                            <PrivateRoute>
                                <Agendamentos/>
                            </PrivateRoute>
                        } />
                        <Route path="/Dashboard" element={
                            <PrivateRoute>
                                <Dashboard/>
                            </PrivateRoute>
                        } />
                        <Route path="/Configuracoes" element={
                            <PrivateRoute requiredRole="ADMIN">
                                <Configuracao/>
                            </PrivateRoute>
                        } />
                            <Route path="/Lancamentos" element={
                            <PrivateRoute requiredRole="ADMIN">
                                <Lancamentos/>
                            </PrivateRoute>
                        } />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </React.StrictMode>
        
        
    )
}



export default Rotas;